import { render, staticRenderFns } from "./ComplaintType.vue?vue&type=template&id=38a20830&"
import script from "./ComplaintType.vue?vue&type=script&lang=js&"
export * from "./ComplaintType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports